import React, { useEffect } from "react";

const DEFAULT_CMS_FE_URL = "/admin/";

function normalizeUrl(value) {
    if (!value) {
        return DEFAULT_CMS_FE_URL;
    }

    const trimmed = value.trim();
    if (!trimmed) {
        return DEFAULT_CMS_FE_URL;
    }

    return trimmed.replace(/\/+$/, "");
}

export default function CmsFeBridgePage() {
    const currentPath = typeof window !== "undefined" ? window.location.pathname : "";
    const currentSearch = typeof window !== "undefined" ? window.location.search : "";
    const currentHash = typeof window !== "undefined" ? window.location.hash : "";
    const currentHost = typeof window !== "undefined" ? window.location.hostname : "";
    const isLocalHost =
        currentHost === "localhost" ||
        currentHost === "127.0.0.1" ||
        currentHost === "::1";
    const normalizedAdminPath = currentPath === "/admin/" ? "/admin" : currentPath;
    const isAdminPath = normalizedAdminPath === "/admin" || normalizedAdminPath.startsWith("/admin/");
    const cmsFeUrl = isAdminPath
        ? `${normalizedAdminPath === "/admin" ? "/admin/" : normalizedAdminPath}${currentSearch}${currentHash}`
        : normalizeUrl(process.env.REACT_APP_CMS_FE_URL);

    useEffect(() => {
        if (!isLocalHost && typeof window !== "undefined") {
            window.location.replace("/admin/");
            return;
        }

        const html = document.documentElement;
        const body = document.body;

        const prevHtmlOverflow = html.style.overflow;
        const prevBodyOverflow = body.style.overflow;
        const prevBodyMargin = body.style.margin;
        const prevBodyHeight = body.style.height;

        html.style.overflow = "hidden";
        body.style.overflow = "hidden";
        body.style.margin = "0";
        body.style.height = "100%";

        return () => {
            html.style.overflow = prevHtmlOverflow;
            body.style.overflow = prevBodyOverflow;
            body.style.margin = prevBodyMargin;
            body.style.height = prevBodyHeight;
        };
    }, [isLocalHost]);

    if (!isLocalHost) {
        return null;
    }

    return (
        <div
            style={{
                position: "fixed",
                inset: 0,
                width: "100%",
                height: "100dvh",
                overflow: "hidden",
                background: "#f5f7fb",
            }}
        >
            <iframe
                title="Unicx CMS FE"
                src={cmsFeUrl}
                style={{
                    width: "100%",
                    height: "100%",
                    display: "block",
                    border: "none",
                    background: "#fff",
                }}
            />
        </div>
    );
}
